import React from "react";

import Select from "components/common/Select";

export type FilterOption = { value: string; label: string };

/**
 * [PRD-3791] One filter dropdown for the billing dashboard tabs — the app's shared
 * Select with the dashboard's fixed width. No visible label: the first option is the
 * "all" choice (value "") and doubles as the placeholder ("All statuses"). The label
 * is kept for screen readers only.
 */
export default function FilterSelect({
  name,
  label,
  options,
  value,
  onChange,
  width = 180,
}: {
  name: string;
  label: string;
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
  width?: number;
}) {
  return (
    <div style={{ width }}>
      <Select
        name={name}
        label={label}
        placeholder={options[0]?.label ?? "All"}
        options={options}
        value={value}
        onChange={(v: string) => onChange(v)}
        labelClass="billing-filter-label"
        helperText=""
        isOptional={false}
        error={false}
      />
    </div>
  );
}
